import AccessUser from "../plugins/AccessUser";
import Globals from "../components/globals";
import Vue from "vue";
import { MAX_LENGTH_NAME } from "@/utils/string";
import { FORM_VALIDATORS } from "@/utils/fieldValidations";
import cacheService from "@/services/cache";
import { mapGetters, mapState } from "vuex";
import { moment } from "@/utils/moment";

export const globalsMixin = {
    data() {
        return {
            AccessUser: AccessUser,
            MAX_LENGTH_NAME,
            FORM_VALIDATORS
        };
    },
    methods: {
        trackEventMatomo(eventCategory, action, name, value) {
            _paq.push([eventCategory, action, name, value]);
        },
        assign(obj) {
            return this._.cloneDeep(obj);
        },

        isClientAdmin(brandId = null) {
            return this.$accessUser.isClientAdmin(brandId);
        },

        isSuperAdmin() {
            // isSuperAdmin : front/src/plugins/AccessUserPlugin.js l.247
            return this.$accessUser.isSuperAdmin();
        },

        isAdmin(type) {
            if (type === "super") {
                return this.isSuperAdmin();
            } else if (type === "client") {
                return this.isClientAdmin();
            }
            return false;
        },

        updateLocalStorageByBrand(updatedBrand) {
            const brands = cacheService.getBrands();
            const preference = cacheService.getRem3rchUser().user.preference;
            const brand = brands.find(b => parseInt(b.id) === parseInt(updatedBrand.id));
            let prefBrand = brand;
            prefBrand.urlImg = Globals.getBaseUrl() + brand.imgPath + brand.logo;
            const currentZone =
                (preference.activated && brand.zones.find(zone => parseInt(zone.id) === parseInt(preference.zone.id))) || brand.zones[0];
            let { id, name, abbreviation } = currentZone;
            let prefZone = { id, name, abbreviation };

            const currentStand =
                (preference.activated && brand.stands.find(stand => parseInt(stand.id) === parseInt(preference.stand.id))) || brand.stands[0];
            ({ id, name } = currentStand);
            let prefStand = { id, name };

            const currentCampaign =
                (preference.activated && brand.campaigns.find(campaign => parseInt(campaign.id) === parseInt(preference.campaign.id))) ||
                brand.campaigns[0];
            ({ id, name } = currentCampaign);
            let { shortName } = currentCampaign;
            let prefCampaigns = { id, name, shortName };
            /**
             * Add DATA localStorage
             */
            cacheService.set("currentBrandId", prefBrand.id);
            cacheService.set("currentZoneId", prefZone.id);
            cacheService.set("currentStandId", prefStand.id);
            cacheService.set("currentCampaignId", prefCampaigns.id ? prefCampaigns.id : "0");

            return prefBrand;
        },

        hasAccessSuperAdmin(functionality = null, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.SUPPER_ADMIN);
        },

        hasAccessDiamAdmin(functionality = null, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.DIAM_ADMIN);
        },

        hasAccessClientAdmin(functionality = null, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.CLIENT_ADMIN);
        },

        hasAccessBothAdmin(functionality = null, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.BOTH_ADMIN);
        },
        hasAccessRead(functionality, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.ACTION.READ);
        },

        hasAccessValidate(functionality, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.ACTION.VALIDATE);
        },

        hasAccessUpdate(functionality, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.ACTION.UPDATE);
        },

        hasAccessUpdateAndCreate(functionality, appsId = [6]) {
            return this.hasAccessUpdate(functionality, appsId) || this.hasAccessCreate(functionality, appsId);
        },

        hasAccessCreate(functionality, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.ACTION.CREATE);
        },

        hasAccessDelete(functionality, appsId = [6]) {
            return this.$accessUser.hasAccess(functionality, appsId, AccessUser.ACTION.DELETE);
        },
        hasDiamAccess(functionality, appsId = [6], ...actions) {
            return this.$accessUser.hasAccessByType(AccessUser.TYPE_DIAM, functionality, appsId, ...actions);
        },

        hasClientAccess(functionality, appsId = [6], ...actions) {
            return this.$accessUser.hasAccessByType(AccessUser.TYPE_CLIENT, functionality, appsId, ...actions);
        },
        hasAccessByProfile(profile, appId = 6) {
            return this.$accessUser.hasAccessByProfile(profile, appId);
        },
        isDiamUser() {
            return this.hasAccessSuperAdmin() || this.$accessUser.type === AccessUser.TYPE_DIAM;
        },
        isClientUser() {
            return this.hasAccessSuperAdmin() || this.$accessUser.type === AccessUser.TYPE_CLIENT;
        },
        hasAccessApplication(application) {
            return cacheService.getCacheObject("access_brand").find(accessBrand => accessBrand.name === application && accessBrand.active === true);
        },
        getLogoBrand() {
            let user = cacheService.getRem3rchUser();
            let brand = Object.values(user.user.brands).find(brand => {
                return parseInt(brand.id, 10) === parseInt(cacheService.getCurrentBrandId(), 10);
            });

            let url = Globals.getBaseUrl() + brand.imgPath + brand.logo;
            return url;
        },

        getTranslate(trans, locale = null) {
            return Globals.getTranslate(trans, locale);
        },
        getValueObject(obj, path, valueDefault = null) {
            return Globals.getValueObject(obj, path, valueDefault);
        },
        deleteItem(array, item) {
            array.splice(array.indexOf(item), 1);
        },
        nl2br(str) {
            if (str && typeof str === "string") {
                str = str.replace(/(\r\n|\n\r|\r|\n)/g, "<br/>" + "$1");
            }
            return str;
        },
        currencyCustomPipe(value, codeIso = "fr-FR", currency = "EUR") {
            return value.toLocaleString(codeIso, {
                style: "currency",
                currency: currency
            });
        },
        /***
         * if ask = true, this method return a bool, to check if we can or not display the price
         * @param value
         * @param isPriceShown
         * @param ask
         * @returns {string}
         */
        displayRealPrice(value, isPriceShown, ask = false) {
            let currentUser = cacheService.getRem3rchUser().user;
            if (currentUser.type == this.AccessUser.TYPE_DIAM) return ask ? true : value;
            return ask ? isPriceShown : isPriceShown ? value : "- -";
        },
        getPathImageComponent(obj, typeFile = null) {
            let ret;
            if (typeFile !== null) {
                ret = this._.find(obj.figures_advanced, o => {
                    return o.id_type_file === typeFile;
                });
            } else {
                let object = Object.values(obj.figures_advanced);
                if (object.length > 0) {
                    ret = object[0];
                }
            }

            if (typeof ret !== "undefined") {
                return ret.big;
            }
            return "";
        },
        dialogWarning(text, title = "", html = "") {
            this.$swal({
                title: title || this.$t("planobuilder.warning"),
                text,
                html,
                type: "warning",
                confirmButtonColor: "#41b4e8",
                confirmButtonText: "Ok"
            });
        },
        async dialogConfirm(text, confirmButton = undefined, cancelButton = undefined) {
            return await this.$swal({
                title: this.$t("basket.warning"),
                text: text,
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "red",
                confirmButtonText: confirmButton || this.$t("actions.remove"),
                cancelButtonText: cancelButton || this.$t("actions.cancel")
            }).catch(() => false);
        },
        dialogSuccess(text = "success") {
            Vue.toast(text, {
                id: "standard-toast",
                className: ["my-toast", "toast-success"],
                horizontalPosition: "right",
                verticalPosition: "bottom",
                mode: "queue"
            });
        },
        dialogErrorToast(text) {
            Vue.toast(text, {
                id: "standard-toast",
                className: ["my-toast", "toast-error"],
                horizontalPosition: "right",
                verticalPosition: "bottom",
                mode: "queue"
            });
        },
        dialogError(text = "error", title = "", html = "") {
            this.$swal({
                title,
                html,
                text: text,
                type: "error",
                confirmButtonText: "OK",
                confirmButtonColor: "grey",
                allowOutsideClick: false,
                allowEscapeKey: false
            });
        },
        catalogueItemClass(index, item, type, rollIndex) {
            let numberItems = type === "mobile" ? 2 : 4;
            return {
                bordered: (index + 1) % numberItems,
                firstRow: index + 1 <= numberItems,
                isNotPublished: !item.is_published,
                "hover-parent": rollIndex === index || rollIndex === index + 1
            };
        },
        formatDate(date) {
            var d = new Date(date),
                month = "" + (d.getMonth() + 1),
                day = "" + d.getDate(),
                year = d.getFullYear();

            if (month.length < 2) month = "0" + month;
            if (day.length < 2) day = "0" + day;

            return [day, month, year].join("-");
        },
        getDateByFormat(date, format) {
            return moment(date).format(format) || "";
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/globals.js